import React from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '../../../Icons/DeleteIcon';
import Button from '../../Button/Button';

/**
 * Bottone di chiusura di una modale.
 */
export default function CloseModalButton({ onClose }) {
  return (
    <Button
      className="v2-modal__close"
      onClick={onClose}
      icon
    >
      <DeleteIcon />
    </Button>
  );
}

CloseModalButton.propTypes = {
  onClose: PropTypes.func.isRequired,
};
